import { baseAPI } from 'services/baseApi';

export const permissionsApi = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    permissionsListing: builder.query({
      query: () => ({
        url: '/permissions/get-all',
        method: 'GET'
      }),
      providesTags: ['PERMISSIONS_LISTING']
    }),
    roleBasedPermissionsListing: builder.query({
      query: () => ({
        url: '/users/get-admin-role-with-permissions',
        method: 'GET'
      }),
      // providesTags: ['PERMISSIONS_LISTING']
    }),
    addPermission: builder.mutation({
      query: (payload) => ({
        url: '/permissions',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['PERMISSIONS_LISTING']
    }),
    updatePermission: builder.mutation({
      query: ({ id, payload }) => ({
        url: '/permissions/' + id,
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['PERMISSIONS_LISTING']
    }),
    deletePermissionPermanently: builder.mutation({
      query: ({ id }) => ({
        url: '/permissions/permanent/' + id,
        method: 'DELETE'
      }),
      invalidatesTags: ['PERMISSIONS_LISTING']
    }),
    deletePermission: builder.mutation({
      query: ({ id }) => ({
        url: '/permissions/' + id,
        method: 'DELETE'
      }),
      invalidatesTags: ['PERMISSIONS_LISTING']
    }),
    restorePermission: builder.mutation({
      query: ({ id }) => ({
        url: '/permissions/restore/' + id,
        method: 'PUT'
      }),
      invalidatesTags: ['PERMISSIONS_LISTING']
    })
  })
});

export const {
  usePermissionsListingQuery,
  useRoleBasedPermissionsListingQuery,
  useAddPermissionMutation,
  useUpdatePermissionMutation,
  useDeletePermissionPermanentlyMutation,
  useDeletePermissionMutation,
  useRestorePermissionMutation
} = permissionsApi;
